/**
 * 客户门户 Store
 *
 * @author system
 * @date 2026-08-11
 * 修改：2026-09-09 API引用改为 @/api/radar/customer-portal/index
 * 修改：2026-09-23 account 中增加 customerName（公司名）
 */

import {
    customerPortalLogin,
    customerPortalLogout,
    getCustomerPortalInfo
} from '@/api/radar/customer-portal/index'

function getCustomerPortalToken() {
    return localStorage.getItem('CUSTOMER_PORTAL_TOKEN')
}

function setCustomerPortalToken(token) {
    localStorage.setItem('CUSTOMER_PORTAL_TOKEN', token)
}

function removeCustomerPortalToken() {
    localStorage.removeItem('CUSTOMER_PORTAL_TOKEN')
}

const state = {
    token: getCustomerPortalToken(),
    account: null,
    isLoggedIn: false,
    needChangePwd: false
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
        if (token) {
            setCustomerPortalToken(token)
        } else {
            removeCustomerPortalToken()
        }
    },

    SET_ACCOUNT: (state, account) => {
        state.account = account
        if (account) {
            localStorage.setItem('CUSTOMER_PORTAL_ACCOUNT', JSON.stringify(account))
        } else {
            localStorage.removeItem('CUSTOMER_PORTAL_ACCOUNT')
        }
    },

    SET_LOGGED_IN: (state, flag) => {
        state.isLoggedIn = flag
    },

    SET_NEED_CHANGE_PWD: (state, need) => {
        state.needChangePwd = need
        if (need) {
            localStorage.setItem('CUSTOMER_PORTAL_NEED_CHANGE_PWD', 'true')
        } else {
            localStorage.removeItem('CUSTOMER_PORTAL_NEED_CHANGE_PWD')
        }
    },

    LOGOUT: (state) => {
        state.token = null
        state.account = null
        state.isLoggedIn = false
        state.needChangePwd = false
        removeCustomerPortalToken()
        localStorage.removeItem('CUSTOMER_PORTAL_ACCOUNT')
        localStorage.removeItem('CUSTOMER_PORTAL_NEED_CHANGE_PWD')
    }
}

const actions = {
    login({ commit }, loginData) {
        return new Promise((resolve, reject) => {
            customerPortalLogin(loginData).then(res => {
                const data = res.data
                commit('SET_TOKEN', data.token)
                commit('SET_ACCOUNT', {
                    accountId: data.accountId,
                    customerId: data.customerId,
                    customerName: data.customerName,   // 新增：公司名
                    contactName: data.contactName,
                    accountType: data.accountType
                })
                commit('SET_LOGGED_IN', true)
                commit('SET_NEED_CHANGE_PWD', data.needChangePwd || false)
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },

    logout({ commit }) {
        return new Promise((resolve) => {
            const token = localStorage.getItem('CUSTOMER_PORTAL_TOKEN')
            if (token) {
                fetch('/api/customer/logout', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }).catch(() => {})
            }
            commit('LOGOUT')
            resolve()
        })
    },

    getInfo({ commit, state }) {
        return new Promise((resolve) => {
            if (state.account) {
                resolve({
                    account: state.account,
                    needChangePwd: state.needChangePwd
                })
                return
            }

            const cachedAccount = localStorage.getItem('CUSTOMER_PORTAL_ACCOUNT')
            const cachedNeedChangePwd = localStorage.getItem('CUSTOMER_PORTAL_NEED_CHANGE_PWD')

            if (cachedAccount) {
                try {
                    commit('SET_ACCOUNT', JSON.parse(cachedAccount))
                    commit('SET_LOGGED_IN', true)
                    if (cachedNeedChangePwd) {
                        commit('SET_NEED_CHANGE_PWD', cachedNeedChangePwd === 'true')
                    }
                    resolve({
                        account: JSON.parse(cachedAccount),
                        needChangePwd: cachedNeedChangePwd === 'true'
                    })
                    return
                } catch (e) {}
            }

            getCustomerPortalInfo().then(res => {
                const data = res.data
                commit('SET_ACCOUNT', {
                    accountId: data.accountId,
                    customerId: data.customerId,
                    customerName: data.customerName,   // 新增：公司名
                    contactName: data.contactName,
                    accountType: data.accountType
                })
                commit('SET_LOGGED_IN', true)
                resolve({
                    account: data,
                    needChangePwd: state.needChangePwd
                })
            }).catch(() => {
                resolve({
                    account: null,
                    needChangePwd: false
                })
            })
        })
    },

    markPasswordChanged({ commit }) {
        commit('SET_NEED_CHANGE_PWD', false)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
